<template>
  <div class="buttons">
    <div class="butL"
         style="position: absolute; top: 43%;  z-index: 999;cursor: pointer;  left: 36.5%;"
         @click="butLclick">
      <img alt="Logo" src="../assets/leftbutton.png" style="height: 60px;"/>
    </div>
    <div class="butR"
         style="  position: absolute;  top: 43%;   z-index: 999; cursor: pointer; left: 85%"
         @click="butRclick">
      <img alt="Logo" src="../assets/rightbutton.png" style="height: 60px;"/>
    </div>
  </div>
  <div class="dbeijing"
      style="background-image: url('shejishi.webp'); width: 100vw; height: 100vh;  /* 绝对定位覆盖全屏 */  position: fixed;  top: 0;  left: 0%;  z-index: -1;  background-size: 100% 100%;  background-position: center center; background-repeat: no-repeat;">
    <div
        style="font-size: 33px;width: 100%;position: fixed; left: 50%;top: 15%;  transform: translate(-50%, -50%);  text-align: center;  pointer-events: none;z-index: 999;color: white">
      <h1>设计师</h1>
    </div>
    <div class="box"
         style="  width: 70px;  height: 570px;  position: absolute; top: 51%;  left: 51%;  transform: translate(-50%, -50%); /* 精确居中定位 */  margin: 0; /* 移除原有margin */">
      <ul id="oul">
        <li class="show0"><img src="../assets/shejishi/maoyali.jpg"/>
          <div class="name-tag">毛亚丽</div>
        </li>
        <li class="show1"><img src="../assets/shejishi/lujunyang.jpg"/>
          <div class="name-tag">鲁俊洋</div>
        </li>
        <li class="show2"><img src="../assets/shejishi/liuyuanyuan.jpg"/>
          <div class="name-tag">刘圆圆</div>
        </li>
        <li class="show3"><img src="../assets/shejishi/zhanhanmei.jpg"/>
          <div class="name-tag">詹寒梅</div>
        </li>
        <li class="show4"><img src="../assets/shejishi/sunshuaikang.jpg"/>
          <div class="name-tag">孙帅康</div>
        </li>
        <li class="show5"><img src="../assets/shejishi/huanghuikai.jpg"/>
          <div class="name-tag">黄会凯</div>
        </li>
        <li class="show6"><img src="../assets/shejishi/huyuqing.webp"/>
          <div class="name-tag">胡雨晴</div>
        </li>
        <li class="show7"><img src="../assets/shejishi/lishijia.jpg"/>
          <div class="name-tag">李世佳</div>
        </li>
        <li class="show8"><img src="../assets/shejishi/zhaoqianhui.webp"/>
          <div class="name-tag">赵千惠</div>
        </li>
        <li class="show9"><img src="../assets/shejishi/wangshuo.jpg"/>
          <div class="name-tag">王硕</div>
        </li>
      </ul>
    </div>
<!--    <div style="position: absolute;-->
<!--    top: 26%;-->
<!--    left: 8%;-->
<!--    z-index: -999;-->
<!--    display: flex;-->
<!--    flex-direction: column;-->
<!--    align-items: center;-->
<!--    width: 30vw; /* 使用视口单位 */-->
<!--    height: 50vh;" class="backgroup4">-->
<!--      <img alt="Logo" src="../assets/shejishi1.png"-->
<!--           style="height: 15vh; /* 使用视口高度单位 */-->
<!--              width: 90vw; /* 使用视口宽度单位 */-->
<!--              object-fit: contain;"/>-->
<!--      <img alt="Logo" src="../assets/shejishi2.png"-->
<!--           style="height: 15vh;-->
<!--              width: 90vw;-->
<!--              margin-top: 15px;-->
<!--              object-fit: contain;"/>-->
<!--      <img alt="Logo" src="../assets/shejishi1.png"-->
<!--           style="height: 15vh;-->
<!--              width: 90vw;-->
<!--              margin-top: 15px;-->
<!--              object-fit: contain;"/>-->
<!--    </div>-->
    <div style="position: absolute;top: 27.5%;left: 11%;z-index: -999; display: flex; flex-direction: column; align-items: center; gap: 80px;background-image: url('shejishi1.png');width: 20vw;height: 10vh;padding-top: 15px;padding-bottom: 10px" class="backgroup1">
      <div style="font-size: 27px;font-weight: bold;color: red">
        <img class="image_4" referrerpolicy="no-referrer" src="../assets/shejishi/sjtb1.png"
             style="height: 80px;width: 80px; object-fit: contain;"/>
        <div style="margin-left: 20px; display: inline-block; vertical-align: top; line-height: 1.4;">
          户型诊断<br><span style="color: #000000;font-size: 17px">沟通需求 提供空间规划</span>
        </div>
      </div>
    </div>
    <div style="position: absolute;top: 44.5%;left: 11%;z-index: -999; display: flex; flex-direction: column; align-items: center; gap: 80px;background-image: url('shejishi2.png');width: 20vw;height: 10vh;padding-top: 15px;padding-bottom: 10px" class="backgroup2">
      <div style="font-size: 27px;font-weight: bold;color: white">
        <img class="image_4" referrerpolicy="no-referrer" src="../assets/shejishi/sjtb2.png"
             style="height: 80px;width: 80px; object-fit: contain;"/>
        <div style="margin-left: 20px; display: inline-block; vertical-align: top; line-height: 1.4;">
          设计方案<br><span style="color: #FFFFFF;font-size: 17px">设计提案 定制专属方案</span>
        </div>
      </div>
    </div>
    <div style="position: absolute;top: 61.5%;left: 11%;z-index: -999; display: flex; flex-direction: column; align-items: center; gap: 80px;background-image: url('shejishi1.png');width: 20vw;height: 10vh;padding-top: 15px;padding-bottom: 10px" class="backgroup3">
      <div style="font-size: 27px;font-weight: bold;color: red">
        <img class="image_4" referrerpolicy="no-referrer" src="../assets/shejishi/sjtb3.png"
             style="height: 80px;width: 80px; object-fit: contain;"/>
        <div style="margin-left: 20px; display: inline-block; vertical-align: top; line-height: 1.4;">
          装修答疑<br><span style="color: #000000;font-size: 16px">风格/套餐/报价 给予专业建议</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ProjectsList',
  data() {
    return {
      projects: [],
      lists: ["show0", "show1", "show2", "show3", "show4", "show5", "show6", "show7", "show8", "show9"],
      flag: true,
      timer: null,
      box: null,
      oli: null,
      butL: null,
      butR: null,
      startX: null,
      startY: null,
    };
  },
  methods: {
    // 新增触摸事件处理
    handleTouchStart(e) {
      this.startY = e.touches[0].clientY;
    },
    handleTouchEnd(e) {
      if (!this.startY) return;
      const endY = e.changedTouches[0].clientY;
      const deltaY = endY - this.startY;
      const deltaX = Math.abs(e.changedTouches[0].clientX - this.startX);
      console.log('1',deltaY,deltaX,Math.abs(deltaY))

      // 垂直滑动距离大于30px且水平滑动小于50px时才触发
      if (Math.abs(deltaY) > 50 && deltaX < 400) {
        if (deltaY > 0) { // 向下滑动
          this.$router.push('/project-list.html'); // 跳转
        } else if (deltaY < 0) { // 向上滑动
          this.$router.push('/building.html');
        }
      }
      this.startY = null;
    },
    handleWheelScroll(e) {
      if (e.ctrlKey || e.metaKey) return; // 过滤组合键操作
      if (e.deltaY > 0) { // 检测向下滚动
        this.$router.push('/building.html');
      }else if (e.deltaY < 0) { // 检测向上滚动
        this.$router.push('/project-list.html'); // 跳转
      }
    },
    handleKeyDown(e) {
      // 阻止Ctrl+加号/减号/鼠标滚轮
      if ((e.ctrlKey === true || e.metaKey) &&
          (e.keyCode === 61 || e.keyCode === 107 ||
              e.keyCode === 173 || e.keyCode === 109 ||
              e.keyCode === 187  || e.keyCode === 189)) {
        e.preventDefault();
      }
    },
    handleWheel(e) {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    },
    handleTouchMove(e) {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    },
    getinfo() {
      this.box = document.querySelector(".box");
      this.oli = document.querySelectorAll(".box ul li")
      this.butL = document.querySelector(".butL");
      this.butR = document.querySelector(".butR");
    },
    butLclick() {
      if (this.flag) {
        // 截取最后一个 放在第一位
        var last = this.lists.pop();
        this.lists.unshift(last);
        this.common();
      }
    },
    async butRclick() {
      console.log('1', this.flag)
      if (this.flag) {
        // 截取第一个 放在最后一位
        var first = this.lists.shift();
        console.log('first', first)
        this.lists.push(first);
        await this.common();
      }
    },
    common() {
      for (var i = 0; i < this.lists.length; i++) {
        // 更换类名 就相当于更换位置
        this.oli[i].className = this.lists[i];
      }
    },


  },
  mounted() {
    // 添加触摸事件监听
    document.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    document.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    this.getinfo();
    // 添加滚轮事件监听
    window.addEventListener('wheel', this.handleWheelScroll);
    // 禁用快捷键缩放
    document.addEventListener('keydown', this.handleKeyDown);
    // 禁用双指缩放（移动端）
    document.addEventListener('wheel', this.handleWheel, { passive: false });
    // 禁用触摸事件缩放
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
  },
  beforeUnmount() {
    // 移除触摸事件监听
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
    // 移除滚轮事件监听
    window.removeEventListener('wheel', this.handleWheelScroll);
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('wheel', this.handleWheel);
    document.removeEventListener('touchmove', this.handleTouchMove);
  },
  computed: {
    containerStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top left',
        width: `${100 / this.scale}%`,
        height: `${100 / this.scale}%`
      };
    }
  },
};
</script>
<style>
/* 新增移动端样式 */
@media (max-width: 768px) {
  .dbeijing{
    z-index: 0!important;
  }
  .box {
    width: 0px !important;
    height: 0px !important;
    position: absolute; /* 改为绝对定位 */
    top: 51%;
    left: 25%;
    transform: translate(-50%, -50%); /* 精确居中定位 */
    margin: 0; /* 移除原有margin */
    display: none;
  }
  .backgroup1 {
    position: absolute;top: 29.5% !important;
    left: 50%  !important;
    z-index: -999; display: flex; flex-direction: column; align-items: center; gap: 80px;
    width: 85vw !important;
    height: 10vh;
    padding-top: 15px;
    transform: translate(-50%, -50%)  !important;

  }
  .backgroup2 {
    position: absolute;top: 46.2% !important;
    z-index: -999; display: flex; flex-direction: column; align-items: center; gap: 80px;
    width: 85vw !important;
    transform: translate(-50%, -50%)  !important;
    left: 50%  !important;

  }
  .backgroup3 {
    position: absolute;top: 62.7% !important;
    z-index: -999; display: flex; flex-direction: column; align-items: center; gap: 80px;
    width: 85vw !important;
    transform: translate(-50%, -50%)  !important;
    left: 50%  !important;
  }

  .buttons{
    display: none;
  }
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.box {

}

.box img {
  transition: all 0.5s linear;
}

.box ul {
  position: relative;
  width: 870px;
  height: 420px;
}

.box ul li {
  height: 420px;
  width: 840px;
  position: absolute;
  top: 50%;
  /*过渡移动的动画*/
  transition: all 0.5s linear;
}
.show5,
.show6,
.show7,
.show8,
.show9 {
  margin-top: 9999px;
}
.show5,
.show6,
.show7,
.show8,
.show9 img {
  height: 10px!important;
  width: 4px!important;
}
/*第一'五张盒子的位置*/
.box ul .show0,
.box ul .show4 {
  width: 564px;
  height: 282px;
  top: 50%;
  margin-top: -146px;
  z-index: 77;
}

.box ul .show0 {
  left: -250px;
}

/*盒子距离*/
.box ul .show1 {
  left: -80px;
}

.box ul .show3 {
  left: 35px;
}

.box ul .show4 {
  left: 626px;
}

/*一、五图片大小*/
.show0 img,
.show4 img {
  width: 254px;
  height: 352px;
}
.show2 img {
  height: 500px;
  width: 340px;
}
/*二、四盒子的位置*/
.box ul .show1,
.box ul .show3 {
  width: 262px;
  height: 336px;
  top: 50%;
  margin-top: -168px;
  z-index: 88;
}

.show1 .name-tag,
.show3 .name-tag {
  transform: translateX(-78%); /* 调整水平偏移量 */
}
/*第二、四张图片大小*/
.show1 img,
.show3 img {
  width: 302px;
  height: 420px;
}
.show2 {
  transform: translateX(-23%) scale(0.8) !important;  /* 新增左移效果 */
}
/*第三张盒子的位置*/
.box ul .show2 {
  width: 340px;
  height: 400px;
  left: 150px;
  top: 0%;
  z-index: 99;
}



.butR {
  position: absolute;
  top: 35%;
  margin-top: -20px;
  z-index: 999;
  cursor: pointer;
  right: -905px;

}

</style>